import React, { useEffect, useState } from 'react'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import handleNumericCheck from '../../../../utils/HandleNumericKeys'
import { useSelector } from "react-redux"
import { ServerRequestProtected, ServerRequestPublic } from '../../../../utils/ServerDataRequest'
import { enumUtil } from '../../../../utils/Enum'
import States, { Gender, UserType } from '../../../../utils/Constants'
import NotificationHandler from '../../../../utils/NotificationHandler'
import Loader from '../../../shared/Loader/Loader'
import { saveAs } from "file-saver"

const BasicInformation = (props) => {
    const { mainUserModal, UserValidationModal, handleUserChange, handleSelectedData, handleImageChange, is, RolesDD, handleSaveUserRoles, RemovePicture } = { ...props }
    let DropDowns = useSelector(state => state?.GeneralDropDownsReducer)
    const getInitials = (firstName, lastName) => {
        const firstInitial = firstName ? firstName[0].toUpperCase() : '';
        const lastInitial = lastName ? lastName[0].toUpperCase() : '';
        return firstInitial + lastInitial;
    };
    const API_URL_Login = enumUtil.controller.Login
    const [isLoading, setIsLoading] = useState(false)
    const [editImage, setEditImage] = useState(false)

    const userInitials = getInitials(mainUserModal?.FirstName, mainUserModal?.LastName);
    const handleReSendEmail = () => {
        let saveModal = {
            TableName: enumUtil.enumAPITableName.User,
            User: {
                data: {
                    ID: mainUserModal?.UserID + "",
                    Email: mainUserModal?.Email
                }
            }
        }
        setIsLoading(true)
        ServerRequestProtected(API_URL_Login + "/GenerateNewTemPassword", 'post', saveModal)
            .then((response) => {
                setIsLoading(false)
                NotificationHandler("Email Sent Successfully", enumUtil.enumtoaster.success)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })


    }
    // console.log(mainUserModal, 'mainUserModal');

    const [pdfFile, setPdfFile] = useState(null);
    const API_URL_Wasabi = enumUtil.controller.Wasabi


    const DownloadFile = (data) => {
        setIsLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": data,
        }, "Download",).then((response) => {
            setIsLoading(false)
            let blob = new Blob([response]);
            saveAs(blob, 'BAA Document.pdf');
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        })
    }

    return (
        <>
            {isLoading ? <Loader /> : null}
            <div className="h-100">
                <div className="h-100 position-relative">
                    <div className="content-wrapper row pb-3 ps-3 align-items-start">
                        <div className="hk-sidebar-v1 col-md-3 p-0 position-relative modal-image-box">
                            {/* <div className="img-container circle " onClick={''}>
                            <img src={mainUserModal.Picture ? mainUserModal.Picture : "https://www.w3schools.com/howto/img_avatar.png"} alt="user profile" />
                            <input
                                type="file"
                                name="changeProfile"
                                id="changeProfile"
                                autoComplete="off"
                                onChange={handleImageChange}
                            />
                            <i className="icon-Group-3404 camera"></i>
                        </div> */}
                            <div className=" position-relative">
                                <div className="img-container s-50 circle">
                                    {mainUserModal?.Picture ? (
                                        <div className="img-container s-50 circle border-2 border-white">
                                            <img src={mainUserModal.Picture} alt="user profile" />
                                        </div>
                                    ) : mainUserModal?.FirstName ? (
                                        mainUserModal?.Gender === "Male" ?
                                            <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-36 text-white za-male">
                                                {userInitials}
                                            </p>

                                            :
                                            mainUserModal?.Gender === "Female" ?
                                                <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-36 text-white za-female">
                                                    {userInitials}
                                                </p>
                                                :
                                                <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-36 text-white  za-others">
                                                    {userInitials}
                                                </p>
                                    ) : (

                                        <p className="align-items-center d-flex h-100 heading justify-content-center w-100 fs-36 text-white za-no-gender">
                                            {/* {userInitials} */}
                                        </p>
                                    )}
                                    {mainUserModal?.Picture ? <></> : <i className="icon-camera-outline fs-24" />}

                                    <input type="file" name="Picture" id="Picture" className='cursor-pointer'
                                        onChange={handleImageChange} />
                                </div>
                                {mainUserModal?.Picture ? (
                                    <div className="ar-edit">
                                        <i className="icon-edit-pencil fs-11" onClick={() => setEditImage(true)}></i>
                                    </div>
                                ) : <></>}

                                {editImage &&
                                    <div className="pic_edit">
                                        <div className="d-flex flex-column row-gap-15">
                                            <div className="d-flex justify-content-between cursor-pointer">
                                                <p className="heading dark-clr">Edit Profile Picture</p>
                                                <i className="icon-x-cros dark-clr fw-600" onClick={() => setEditImage(false)}></i>
                                            </div>
                                            <div class="hk-imgHandler">
                                                <div className="d-flex hk-imgHandler img-container justify-content-center mx-auto s-85">
                                                    {mainUserModal?.Picture ? <img src={mainUserModal?.Picture} /> :

                                                        mainUserModal?.Gender === 'Male' ? <p class="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male rounded-1">{userInitials}</p> : mainUserModal?.Gender === 'Female' ? <p class="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-female rounded-1">{userInitials}</p> : <p class="align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-others rounded-1">{userInitials}</p>


                                                    }
                                                    <input type="file"
                                                        id="Picture"
                                                        name="Picture"
                                                        onChange={handleImageChange}
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="text-center mb-1">
                                                    <button className="btn rounded px-2 btn-validate hk-imgHandler mx-auto"><i className="icon-upload me-1 fs-11"></i>
                                                        <input type="file"
                                                            className=''
                                                            id="Picture"
                                                            name="Picture"
                                                            onChange={handleImageChange}
                                                        />
                                                        Upload Image</button>
                                                </div>
                                                <div className="d-flex align-items-center gap-6">
                                                    <div className="br-bottom-1 br-clr-light w-100"></div>
                                                    <p className="heading light-clrs fs-11">or</p>
                                                    <div className="br-bottom-1 br-clr-light w-100"></div>
                                                </div>
                                                {/* onClick={RemovePicture} */}
                                                <p className="heading mt-1 del_item text-center cursor-pointer" onClick={RemovePicture}>Delete Exisiting</p>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="form-group mt-4 input">
                                <label htmlFor="firstName">First Name<span className='req'>*</span></label>
                                <div className={UserValidationModal.FirstNameVal ? 'form-group input error' : 'form-group'}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="FirstName"
                                        name="FirstName"
                                        autoComplete="off"
                                        value={mainUserModal.FirstName}
                                        onChange={handleUserChange}
                                    />
                                    {UserValidationModal.FirstNameVal}
                                </div>
                            </div>
                            <div className="form-group input">
                                <label htmlFor="middleName">Middle Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="MiddleName"
                                    name="MiddleName"
                                    autoComplete="off"
                                    value={mainUserModal.MiddleName}
                                    onChange={handleUserChange}
                                />
                            </div>
                            <div className="form-group input">
                                <label htmlFor="lastName">Last Name<span className='req'>*</span></label>
                                <div className={UserValidationModal.LastNameVal ? 'form-group input error' : 'form-group'}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="LastName"
                                        name="LastName"
                                        autoComplete="off"
                                        value={mainUserModal.LastName}
                                        onChange={handleUserChange}
                                    />
                                    {UserValidationModal.LastNameVal}
                                </div>
                            </div>
                            {/* <div className="form-group input">
                            <label htmlFor="RoleID">Role<span className='req'>*</span></label>
                            <div className={UserValidationModal.RoleVal ? 'form-group input error' : 'form-group'}>
                                <SuperSearchList
                                    type="client"
                                    id='RoleID'
                                    name='RoleID'
                                    searchValue={mainUserModal.RoleID}
                                    data={RolesDD}
                                    onChange={handleUserChange}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'

                                />
                                {UserValidationModal.RoleVal}
                            </div>
                        </div> */}
                            <div className="form-group input">
                                <label htmlFor="Gender">Gender<span className='req'>*</span></label>
                                <div className={UserValidationModal.GenderVal ? 'form-group input error' : 'form-group'}>
                                    <SuperSearchList
                                        type="client"
                                        id='Gender'
                                        name='Gender'
                                        searchValue={mainUserModal.Gender}
                                        data={Gender}
                                        onChange={handleUserChange}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={UserValidationModal.UserTypeVal}
                                    />
                                    {UserValidationModal.GenderVal}
                                </div>
                            </div>
                            <div className="form-group input">
                                <label htmlFor="UserType">User Type<span className='req'>*</span></label>
                                <div className={UserValidationModal.UserTypeVal ? 'form-group input error' : 'form-group'}>
                                    <SuperSearchList
                                        type="client"
                                        id='UserType'
                                        name='UserType'
                                        searchValue={mainUserModal.UserType}
                                        data={UserType}
                                        onChange={handleUserChange}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={UserValidationModal.UserTypeVal}
                                    />
                                    {UserValidationModal.UserTypeVal}
                                </div>
                            </div>
                            <div className='d-flex align-items-center gap-6'>
                                <div className="custom_check_box d-flex">
                                    <input
                                        type="checkbox"
                                        className="form-check-input p-0 mt-0"
                                        id="IsPublicAccessible"
                                        name="IsPublicAccessible"
                                        autoComplete="off"
                                        checked={mainUserModal?.IsPublicAccessible || mainUserModal?.IsPublicAccessible === 'true'}
                                        onChange={(e) => handleUserChange(e)}
                                    />
                                </div>
                                <p className='text font-m'>Is Public Accessible</p>
                            </div>
                        </div>
                        <div className="col-md-9 pe-0 tab-form-col">
                            <div className="gap_row row row-half m-0">
                                <p className="heading p-2 bg_blue">Address Information</p>
                                <div className="form-group input p-0 mt-1 ps-1">
                                    <label htmlFor="Address">Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="Address"
                                        name="Address"
                                        autoComplete="off"
                                        value={mainUserModal.Address}
                                        onChange={handleUserChange}
                                    />
                                </div>
                                <div className="col-md-4 ps-1">
                                    <div className="form-group input h-100 justify-content-center">
                                        <label htmlFor="">State</label>
                                        <SuperSearchList
                                            type="client"
                                            id='State'
                                            name='State'
                                            searchValue={mainUserModal.State}
                                            data={States}
                                            onChange={handleUserChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group input">
                                        <label htmlFor="City">City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="City"
                                            name="City"
                                            autoComplete="off"
                                            value={mainUserModal.City}
                                            onChange={handleUserChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 pe-0">
                                    <div className="form-group input">
                                        <label htmlFor="Zip">Zip</label>
                                        <div className={UserValidationModal.ZipCodeLengthVal ? 'form-group input error' : 'form-group'} >
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="ZipCode"
                                                name="ZipCode"
                                                autoComplete="off"
                                                maxLength={9}
                                                onKeyPress={handleNumericCheck}
                                                value={mainUserModal.ZipCode}
                                                onChange={handleUserChange}
                                            />
                                            {UserValidationModal.ZipCodeLengthVal}
                                        </div>
                                    </div>
                                </div>
                                <p className="heading p-2 bg_blue mt-2">Contact Information </p>
                                <div className="col-md-4 ps-1 mt-2">
                                    <div className="form-group input">
                                        <label htmlFor="Cell">Cell #</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="Cell"
                                            name="Cell"
                                            autoComplete="off"
                                            maxLength={10}
                                            onKeyPress={handleNumericCheck}
                                            value={mainUserModal.Cell}
                                            onChange={handleUserChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2">
                                    <div className="form-group input">
                                        <label htmlFor="PhoneNumber">Phone Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="PhoneNumber"
                                            name="PhoneNumber"
                                            autoComplete="off"
                                            maxLength={10}
                                            onKeyPress={handleNumericCheck}
                                            value={mainUserModal.PhoneNumber}
                                            onChange={handleUserChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 pe-0">
                                    <div className="form-group input">
                                        <label className="d-flex align-items-center justify-content-between">
                                            <p>Email<span className="req pe-2">*</span></p>

                                            {mainUserModal?.IsVarified ?
                                                <span className="d-flex align-items-center">
                                                    <i className="verified bi bi-check cursor-default fs-20 za-harlequen-green-clr"></i>
                                                    <span className='text fs-11 za-harlequen-green-clr'>Verified</span>
                                                </span>

                                                :
                                                mainUserModal?.UserID > 0 ?
                                                    // <span className="d-flex align-items-center" onClick={handleReSendEmail}>
                                                    //     ReSend
                                                    // </span> :
                                                    <span className="d-flex align-items-center gap-1" onClick={handleReSendEmail}>
                                                        <i className="icon-Resend cursor-default fs-12"></i>
                                                        <span className='text fs-11 validate-color'>Resend</span>
                                                    </span>
                                                    :
                                                    <></>
                                            }

                                        </label>
                                        <div className={UserValidationModal.EmailVal ? 'form-group input error' : 'form-group'}>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="Email"
                                                name="Email"
                                                autoComplete="off"
                                                value={mainUserModal.Email}
                                                onChange={handleUserChange}
                                            />
                                            {UserValidationModal.EmailVal}
                                        </div>
                                    </div>
                                </div>
                                <p className="heading p-2 bg_blue mt-2">Other Information</p>
                                <div className="col-md-4 mt-2">
                                    <div className="form-group input h-100 justify-content-center">
                                        <label className='mb-1' htmlFor="">Department</label>
                                        <SuperSearchList
                                            type="client"
                                            id='DepartmentID'
                                            name='DepartmentID'
                                            searchValue={mainUserModal.DepartmentID}
                                            data={DropDowns?.Department}
                                            onChange={handleUserChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        // filterWith="startsWith"
                                        // tableHeight="200px"
                                        // tableWidth="100%"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2">
                                    <div className="form-group input h-100 justify-content-center">
                                        <label className='mb-1' htmlFor="">Designation</label>
                                        <SuperSearchList
                                            type="client"
                                            id='DesignationID'
                                            name='DesignationID'
                                            searchValue={mainUserModal.DesignationID}
                                            data={DropDowns?.Designation}
                                            onChange={handleUserChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        // filterWith="startsWith"
                                        // tableHeight="200px"
                                        // tableWidth="100%"
                                        />
                                    </div>
                                </div>
                                <div className='col-md-4 mt-2 pe-0'>
                                    <div className="form-group input h-100 justify-content-center">
                                        <label className='mb-1' >Reporting To</label>
                                        <SuperSearchList
                                            type="client"
                                            id='RefProviderID'
                                            name='RefProviderID'
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 d-flex align-items-center gap-3 mt-12 lh-23">

                                    <div className='d-flex align-items-center gap-6'>
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input p-0 m-0"
                                                id="IsProvider"
                                                name="IsProvider"
                                                autoComplete="off"
                                                checked={mainUserModal?.IsProvider || mainUserModal?.IsProvider === 'true'}
                                                onChange={(e) => handleUserChange(e)}
                                            />
                                        </div>
                                        <p className='text font-m'>Is Provider</p>
                                    </div>

                                    <div className='d-flex align-items-center gap-6'>
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input p-0 mt-0"
                                                id="IsStaff"
                                                name="IsStaff"
                                                autoComplete="off"
                                                checked={mainUserModal?.IsStaff || mainUserModal?.IsStaff === 'true'}
                                                onChange={(e) => handleUserChange(e)}
                                            />
                                        </div>
                                        <p className='text font-m'>Is Staff</p>
                                    </div>

                                    {
                                        mainUserModal?.UserID > 0 ? (
                                            mainUserModal?.requireBAA ? (
                                                <>
                                                    {/* <span className="d-flex align-items-center">
                                                        <i className="verified bi bi-check cursor-default fs-20 za-harlequen-green-clr"></i>
                                                        <span className="text fs-11 ">
                                                            BAA signed by {mainUserModal?.BBASignedBy ? mainUserModal?.BBASignedBy : 'N/A'} on {mainUserModal?.BAASignDate ? mainUserModal?.BAASignDate : 'N/A'}    <i className="icon-download-svgrepo-com" onClick={() => { DownloadFile(mainUserModal?.BAAPDFURL); }} />
                                                        </span>
                                                    </span> */}

                                                    {mainUserModal?.IsBAAAgree ? (
                                                        <div className="d-flex align-items-center gap-6 baa-user-popup">
                                                            <i className='icon-check fs-15 fw-900 orange-drk'></i>
                                                            <p className='text'>BAA signed by {mainUserModal?.BBASignedBy ? mainUserModal?.BBASignedBy : 'N/A'} on {mainUserModal?.BAASignDate ? mainUserModal?.BAASignDate : 'N/A'}</p>
                                                            <button className='border-0 no-width Sdownload-btn' onClick={() => { DownloadFile(mainUserModal?.BAAPDFURL); }}>
                                                                <i className="icon-download-svgrepo-com fs-18" />
                                                            </button>
                                                        </div>
                                                    ) :
                                                        null
                                                    }

                                                </>
                                            ) : null
                                        ) : (
                                            <div className="d-flex align-items-center gap-6">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input p-0 mt-0"
                                                        id="requireBAA"
                                                        name="requireBAA"
                                                        autoComplete="off"
                                                        checked={
                                                            mainUserModal?.requireBAA === true ||
                                                            mainUserModal?.requireBAA === "true"
                                                        }
                                                        onChange={handleUserChange}
                                                    />
                                                </div>
                                                <p className="text font-m">Requires BAA</p>
                                            </div>
                                        )
                                    }
                                </div>

                                {mainUserModal?.IsProvider === 'True' || mainUserModal?.IsProvider === 'true' || mainUserModal?.IsProvider ?

                                    <div className="col-md-4 mt-2">
                                        {mainUserModal?.IsProvider === 'True' || mainUserModal?.IsProvider === 'true' || mainUserModal?.IsProvider ?
                                            <div className="form-group input">
                                                <label htmlFor="Gender">Provider<span className='req'>*</span></label>
                                                <div className={UserValidationModal.ProviderVal ? 'form-group input error' : 'form-group'}>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='ProviderID'
                                                        name='ProviderID'
                                                        searchValue={mainUserModal.ProviderID}
                                                        data={DropDowns?.Provider}
                                                        onChange={handleUserChange}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                        inputError={UserValidationModal.ProviderVal}
                                                    />
                                                    {UserValidationModal.ProviderVal}
                                                </div>
                                            </div>
                                            : <></>
                                        }
                                    </div> : <></>}
                                {mainUserModal?.IsStaff === 'True' || mainUserModal?.IsStaff === 'true' || mainUserModal?.IsStaff ?
                                    <div className={`col-md-4 mt-2 ${mainUserModal?.IsProvider === 'True' || mainUserModal?.IsProvider === 'true' || mainUserModal?.IsProvider ? 'pe-0' : ''}`}>
                                        {mainUserModal?.IsStaff === 'True' || mainUserModal?.IsStaff === 'true' || mainUserModal?.IsStaff ?
                                            <div className="form-group input">
                                                <label htmlFor="Gender">Staff<span className='req'>*</span></label>
                                                <div className={UserValidationModal.StaffVal ? 'form-group input error' : 'form-group'}>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='StaffID'
                                                        name='StaffID'
                                                        searchValue={mainUserModal.StaffID}
                                                        data={DropDowns?.Staff}
                                                        onChange={handleUserChange}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                        inputError={UserValidationModal.StaffVal}
                                                    />
                                                    {UserValidationModal.StaffVal}
                                                </div>
                                            </div>
                                            : <></>
                                        }
                                    </div> : <></>}

                            </div>
                        </div>
                    </div>

                </div>
            </div >
        </>
    )
}

export default BasicInformation